import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { Term } from 'types/api';
import { errorHandler } from 'utils/ErrorHandler';
import { BOOKING_EXCEL_REQUEST, REQUEST_BOOKING_EXCEL_EXPORT } from '../index';
import { BookingTermType } from '../types';

export function useMutationRequestBookingExcel() {
  const [excelDownloadLoading, setExcelDownloadLoading] =
    useState<boolean>(false);

  const [requestBookingExcelExport] = useMutation(REQUEST_BOOKING_EXCEL_EXPORT);
  const [bookingExcelRequest, { data, stopPolling }] = useLazyQuery(
    BOOKING_EXCEL_REQUEST,
    { pollInterval: 5000 },
  );

  const handleRequestBookingExcel = async (filter: Record<string, any>) => {
    try {
      setExcelDownloadLoading(true);

      const data = await requestBookingExcelExport({
        variables: {
          filter,
        },
      });

      if (data) {
        const { id } = data.data.requestBookingExcelExport;

        await bookingExcelRequest({
          variables: { id },
        });
      }
    } catch (error) {
      errorHandler(error);
      setExcelDownloadLoading(false);
    }
  };

  useEffect(() => {
    if (data && data.booking.bookingExportRequest.url !== null) {
      window.open(data.booking.bookingExportRequest.url);

      setExcelDownloadLoading(false);
      stopPolling();
    }
  }, [data]);

  return { excelDownloadLoading, handleRequestBookingExcel };
}
